// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"recipientInput_wrapper__17XPh"};